import React from "react";
import { observer } from "mobx-react-lite";
import {
  Box,
  HStack,
  Icon,
  Popover,
  Portal,
  Separator,
  Stack,
  Text,
} from "@chakra-ui/react";
import { useStores } from "../../shared/stores/RootStore";
import { Link } from "react-router-dom";
import { appRoutes } from "../../../App";
import { ArrowForwardIcon } from "../../shared/views/icons";

const ProjectMapSelectionPopoverBase: React.FC = () => {
  const { projectStore } = useStores();

  if (projectStore.mapSelection === undefined) return null;

  return (
    <Popover.Root
      size={"sm"}
      modal
      lazyMount
      unmountOnExit
      open
      onOpenChange={({ open }) => {
        if (!open) {
          projectStore.clearMapSelection();
        }
      }}
      positioning={{
        offset: {
          mainAxis: 14,
        },
      }}
    >
      <Popover.Trigger asChild>
        {projectStore.mapSelection && (
          <Box
            position={"absolute"}
            left={projectStore.mapSelection.x}
            top={projectStore.mapSelection.y}
          ></Box>
        )}
      </Popover.Trigger>
      <Portal>
        <Popover.Positioner>
          <Popover.Content>
            <Popover.Arrow />
            <Popover.CloseTrigger />
            <Stack separator={<Separator />} gap={0}>
              {projectStore.mapSelection.projects.map((p) => (
                <Link
                  key={p.id}
                  to={appRoutes.project(p.id)}
                  onClick={() => projectStore.clearMapSelection()}
                >
                  <HStack
                    py={2}
                    px={2}
                    _hover={{
                      textDecor: "underline",
                    }}
                  >
                    <Stack flexGrow={1} gap={0}>
                      <Text
                        fontWeight={"semibold"}
                        textTransform={"uppercase"}
                        fontSize="2xs"
                        opacity={0.6}
                      >
                        {p.city}
                      </Text>
                      <Text>{p.name}</Text>
                    </Stack>

                    <Icon as={ArrowForwardIcon} color="primary.600" />
                  </HStack>
                </Link>
              ))}
            </Stack>
          </Popover.Content>
        </Popover.Positioner>
      </Portal>
    </Popover.Root>
  );
};

export const ProjectMapSelectionPopover = observer(
  ProjectMapSelectionPopoverBase
);
